import { render, staticRenderFns } from "./ManageBannerGroups.vue?vue&type=template&id=05cc59eb&"
import script from "./ManageBannerGroups.vue?vue&type=script&lang=js&"
export * from "./ManageBannerGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports